export const ExternalLinks = {
  betaFAQ: 'https://help.playvs.com/en/articles/9931346-playvs-beta-faq',
  queueFAQ:
    'https://help.playvs.com/en/articles/8269392-joining-the-playvs-match-queue',
}
